import {
  FETCH_TEMPLATES,
  FETCH_TEMPLATES_SUCCESS,
  FETCH_TEMPLATES_FAILURE,
  FETCH_TEMPLATE_FAILURE,
  ADD_TEMPLATE,
  ADD_TEMPLATE_SUCCESS,
  ADD_TEMPLATE_FAILURE,
  UPDATE_TEMPLATE,
  UPDATE_TEMPLATE_SUCCESS,
  UPDATE_TEMPLATE_FAILURE,
  REMOVE_TEMPLATE,
  REMOVE_TEMPLATE_SUCCESS,
  REMOVE_TEMPLATE_FAILURE,
} from './types'

export const fetchTemplates = (accessToken) => ({
  type: FETCH_TEMPLATES,
  payload: { accessToken },
})

export const fetchTemplatesSuccess = (payload) => ({
  type: FETCH_TEMPLATES_SUCCESS,
  payload,
})

export const fetchTemplatesFailure = (payload) => ({
  type: FETCH_TEMPLATES_FAILURE,
  payload,
})

export const fetchTemplateFailure = (payload) => ({
  type: FETCH_TEMPLATE_FAILURE,
  payload,
})

export const addTemplate = (templateName, template, accessToken) => ({
  type: ADD_TEMPLATE,
  payload: { templateName, template, accessToken },
})

export const addTemplateSuccess = (payload) => ({
  type: ADD_TEMPLATE_SUCCESS,
  payload,
})

export const addTemplateFailure = (payload) => ({
  type: ADD_TEMPLATE_FAILURE,
  payload,
})

export const updateTemplate = (templateName, template, accessToken) => ({
  type: UPDATE_TEMPLATE,
  payload: { templateName, template, accessToken },
})

export const updateTemplateSuccess = (payload) => ({
  type: UPDATE_TEMPLATE_SUCCESS,
  payload,
})

export const updateTemplateFailure = (payload) => ({
  type: UPDATE_TEMPLATE_FAILURE,
  payload,
})

export const removeTemplate = (templateName, accessToken) => ({
  type: REMOVE_TEMPLATE,
  payload: { templateName, accessToken },
})

export const removeTemplateSuccess = (payload) => ({
  type: REMOVE_TEMPLATE_SUCCESS,
  payload,
})

export const removeTemplateFailure = (payload) => ({
  type: REMOVE_TEMPLATE_FAILURE,
  payload,
})
